// extracted by mini-css-extract-plugin
export default {"PortalLogin":"Login_PortalLogin__F9HF5","loaderWrapper":"Login_loaderWrapper__N-Dpa","loader":"Login_loader__TZjqD"};